export enum WorkTimeType {
  FullTime = "FULL_TIME",
  PartTime = "PART_TIME",
  Variable = "VARIABLE_TIME",
  Default = "",
}
